export const version = 'kunde-v1.20.0-SNAPSHOT-f508bff3061d28e4752993ad37c1150695a566e8';